import { useTranslation } from 'react-i18next';

import { LanguageSelector } from 'new-components/LanguageSelector/LanguageSelector';
import { getAccessToken } from 'utils/accessToken';

import './LanguageSelectorNotAuthenticated.scss';

export const LanguageSelectorNotAuthenticated = () => {
  const { i18n } = useTranslation();

  const accessToken = getAccessToken();

  if (accessToken) return null;

  const handleLanguageChange = (language: string | string[]) => {
    if (typeof language === 'string') {
      i18n.changeLanguage(language);
    }
  };

  return (
    <div className="language-selector-not-authenticated">
      <LanguageSelector
        labelMode="nativeName"
        normalizeLanguageCode
        value={i18n.language}
        onChange={handleLanguageChange}
      />
    </div>
  );
};
